export default {
  'password': '비밀번호를 입력해 주십시오.',
  'passwordError': '비밀번호는 8-20자리이며 영문 대 소문자, 숫자 및 특수 문자 중 3가지 이상이 포함되어야 합니다.',
  'passwordAgain': '비밀번호를 다시 입력해 주십시오.',
  'passwordNotSame': '입력한 암호가 일치하지 않습니다. 다시 입력하십시오.',
  'requiredVerifyCode': '인증 코드를 입력하세요',
  'verifyCode': '인증 코드 오류'
}
